import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import { AppState } from '../store/app.state';
import { selectIsSuperAdmin } from '../store/auth/auth.selectors';

export const superAdminGuard: CanActivateFn = () => {
  const store = inject(Store<AppState>);
  const router = inject(Router);

  return store.select(selectIsSuperAdmin).pipe(
    take(1),
    map((isSuperAdmin) => {
      if (!isSuperAdmin) {
        router.navigate(['/dashboard']);
        return false;
      }
      return true;
    })
  );
};
